import { render, staticRenderFns } from "./QuoteTab.vue?vue&type=template&id=670923ec&lang=html&"
import script from "./QuoteTab.vue?vue&type=script&lang=js&"
export * from "./QuoteTab.vue?vue&type=script&lang=js&"
import style0 from "./QuoteTab.vue?vue&type=style&index=0&id=670923ec&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports